import React from 'react';
import { Route, Routes } from 'react-router-dom';
import GoogleMap from '../../../Maps/GoogleMap/index';
import VectorMap from '../../../Maps/VectorMap/index';
import VectorMapWithRequestData from '../../../Maps/VectorMapWithRequestData';

export default () => (
  <Routes>
    <Route path="/maps/google_map" element={<GoogleMap />} />
    <Route path="/maps/vector_map" element={<VectorMap />} />
    <Route path="/maps/map_with_request" element={<VectorMapWithRequestData />} />
  </Routes>
);
